module.exports = __webpack_public_path__ + "static/onTheIssues_PublicSafety_1-f2e8eaa3f6c790119113100a694a0b48.jpg";